<template lang="pug">
  .b-project-file-categories-container()
    .__directory-container
      Icon.__directory-icon(name="folder-open")
      | Папки
      .__directory-creator(v-if="isEditable" @click="$emit('createCategory')" title="Создать папку")
        Icon(name="plus-colorless" pointer)
    ._items
      ProjectFileCategoryFrame._item(
        v-for="(fileCategoryData, index) in filesCategoriesData"
        :key="fileCategoryData.id"
        :fileCategoryData="fileCategoryData"
        :filesData="getCategoryFiles(fileCategoryData)"
        :active="fileCategoryData['@id'] === selectedCategory"
        :isEditable="isEditable"
        @fileDrop="$emit('fileDrop', fileCategoryData['@id'])"
        @click="$emit('clickFileCategory', fileCategoryData['@id'])"
        @rename="$emit('clickMenu', 'rename', fileCategoryData, index)"
        @delete="checkDeleteMenu(fileCategoryData, index)"
      )
</template>

<script>
import ProjectFileCategoryFrame from '@/components/project/ProjectFileCategoryFrame.vue';

export default {
  name: 'ProjectFileCategoriesContainer',
  components: { ProjectFileCategoryFrame },
  props: {
    filesCategoriesData: {
      type: Array,
      default: () => [],
    },
    filesData: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: String,
      default: null,
    },
    isEditable: Boolean,
  },
  methods: {
    getCategoryFiles(fileCategoryData) {
      return this.filesData.filter(fileData => fileCategoryData.id === null || fileData.category === fileCategoryData['@id']);
    },
    checkDeleteMenu(fileCategoryData, index) {
      if (this.getCategoryFiles(fileCategoryData).length !== 0) {
        this.$alert('Удалить можно только пустую папку.~Переместите файлы в другие папки или удалите их.');
        return;
      }

      this.$emit('clickMenu', 'delete', fileCategoryData, index);
    },
  },
};
</script>

<style scoped lang="scss">
@use 'sass:list';
  .project-file-categories-container {
    width: 100%;
    position: relative;

    &__items {
      display: flex;
      flex-direction: column;
      margin-top: 24px;

      @media (max-width: 1400px) {
        flex-direction: row;
        overflow-x: scroll;
      }
    }

    &__item {
      margin-right: 10px;
      background-color: var(--main-bg);
      flex-shrink: 0;

      @media (max-width: 1400px) {
        background-color: var(--color-white);
      }

      $colors: #C8E7FF, #C7E7DA, #C1E0EB, #A1CCF4, #6CD796, #FED56D, #FFBB94, #F28AC6, #4F5321;

      @each $color in $colors {
        $i: index($colors, $color);
        &:nth-child(#{$i}):before { background-color: $color }
      }
    }

    &__directory {
      &-container {
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--color-super-light);
        padding-bottom: 12px;
        margin-right: 15px;
        font-size: 18px;
      }

      &-icon {
        width: 17px;
        height: 17px;
        margin-right: 7px;
      }

      &-creator {
        margin: 0 0 0 auto;
        padding-right: 5px;
        svg {
          fill: var(--color-light-dark);
        }
      }
    }
  }

</style>
